<script setup lang="ts">
  import { LazyModalSignUp } from '#components';

  defineProps<{
    slides: (IGameData & { img: string })[];
  }>();

  const { handleGameClick } = useGameLauncher();

  async function onGameClick(item: IGameData) {
    if (!stores.user.isLoggedIn) {
      await stores.modals.open('sign-up', LazyModalSignUp);
      return;
    }

    await handleGameClick(item);
  }
</script>

<template>
  <div class="rounded-[10px] border border-white/20 bg-white/5 p-4 h-fit w-[242px] md:w-[282px]">
    <UCarousel
      v-slot="{ item }"
      :items="slides"
      arrows
      :ui="{
        item: `h-full relative grow-1 ps-0 rounded-[10px] overflow-hidden`,
        container: 'ms-0 w-full h-full',
        root: 'h-full',
        viewport: 'h-full',
        prev: 'rounded-full p-0 !w-[60px] absolute top-[50%] -left-8 !h-[60px] bg-white text-black flex justify-center items-center cursor-pointer hover:bg-white active:bg-white',
        next: 'rounded-full p-0 !w-[60px] absolute top-[50%] -right-8 !h-[60px] bg-white text-black flex justify-center items-center cursor-pointer hover:bg-white active:bg-white',
      }"
      align="center"
      class="w-full mx-auto"
      loop
    >
      <CoreImage
        :key="item.img"
        class="will-change-transform !rounded-[10px] cursor-pointer transition-transform duration-200 ease-in-out transform scale-100 hover:scale-107"
        :src="item.img"
        @click="onGameClick(item)"
      />
    </UCarousel>
  </div>
</template>
